module.exports = __webpack_public_path__ + "img/slides-mepyd-11@3x.bba68386.png";